import { HowItWorksABCTest } from "./HowItWorksABCTest";

export { HowItWorksABCTest };
